import { ReactNode } from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex';
import { componentToken, space } from '../../style/utils';

const Wrapper = styled(Flex)<{ $padding?: string }>`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.border.divider};
  border-radius: ${componentToken('card.radius')};
  padding: ${({ $padding }) => $padding ?? space('xxl')};
`;

type Props = {
  children?: ReactNode;
  padding?: string;
};

const Card = ({ children, padding }: Props) => (
  <Wrapper $padding={padding}>{children}</Wrapper>
);

export default Card;
